export const useSeoHelper = () => {
  const route = useRoute();
  const url = useRequestURL();
  const page = computed(() => parseInt(route.query.page) || 1);

  const getAbsoluteUrl = (path) => {
    const baseUrl = url.protocol + '//' + url.host;
    return baseUrl + path;
  };

  const canonicalUrl = computed(() => {
    return getAbsoluteUrl(route.path);
    // return page.value === 1
    //   ? getAbsoluteUrl(route.path)
    //   : getAbsoluteUrl(route.fullPath);
  });

  const title = (title) => {
    return page.value === 1 ? title : `${title} | Страница - ${page.value}`;
  };

  return { getAbsoluteUrl, canonicalUrl, title };
};
